export default "__VITE_ASSET__DGCcbBYE__"